module.exports = __webpack_public_path__ + "img/SketchPng3e030af5cace0d348c3d9e44f6608a16b1d9de4387a02118d808f0c037ca72b2.56fd493f.png";